"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = require("react");
var useElementReference = function useElementReference(selector) {
  var rootMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    element = _useState2[0],
    setElement = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isElementVisible = _useState4[0],
    setElementVisible = _useState4[1];
  var options = {
    root: null,
    rootMargin: "".concat(rootMargin, "px"),
    threshold: threshold
  };
  (0, _react.useLayoutEffect)(function () {
    if (selector) {
      setElement(document.querySelector(".".concat(selector)));
    }
  }, []);
  (0, _react.useEffect)(function () {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setElementVisible(entry.isIntersecting);
      });
    }, options);
    if (element) {
      observer.observe(element);
    }
    return function () {
      return element ? observer.unobserve(element) : undefined;
    };
  }, [element]);
  return {
    isElementVisible: isElementVisible
  };
};
var _default = useElementReference;
exports["default"] = _default;